import { ApolloError } from '@apollo/client';
import { Center, Spinner, SpinnerProps } from '@chakra-ui/react';
import ErrorMessage from './ErrorMessage';

export interface LoadingWrapperProps {
    error?: ApolloError | undefined;
    isLoading: boolean;
    children?: JSX.Element | null;
    color?: SpinnerProps['color'];
}

const LoadingWrapper = ({
    error,
    isLoading,
    children,
    color,
}: LoadingWrapperProps) => {
    if (isLoading) {
        return (
            <Center w="full" h="sm">
                <Spinner color={color} />
            </Center>
        );
    }
    if (error) {
        return <ErrorMessage message={error.message} />;
    }

    return <>{children}</>;
};

export default LoadingWrapper;
